import { render, staticRenderFns } from "./FilterNavSizes.vue?vue&type=template&id=1022a7ac&"
import script from "./FilterNavSizes.vue?vue&type=script&lang=js&"
export * from "./FilterNavSizes.vue?vue&type=script&lang=js&"
import style0 from "./FilterNavSizes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports